import React from "react";
import { COLORS } from "shared/consts";
import {IconProps} from './index.tsx';

export const Support: React.FC<IconProps> = ({
                                                  fill = COLORS.FG.SOFT,
                                                  width = 24,
                                                  height = 24,
                                                  className,
                                              }) => {
    return (
        <svg className={className} viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"
             width={width} height={height} fill="none">
            <rect id="24 / Communication / Comments" width={width} height={height} x="0.000000" y="0.000000"/>
            <path id="Union"
                  d="M16.5662 16.6668C16.3536 16.5572 16.118 16.5 15.8788 16.5L8 16.5C6.067 16.5 4.5 14.933 4.5 13L4.5 7C4.5 6.17157 5.17157 5.5 6 5.5L18 5.5C18.8284 5.5 19.5 6.17157 19.5 7L19.5 16L19.5 18L19.5 18.1795L16.5662 16.6668ZM6 4C4.34315 4 3 5.34315 3 7L3 13C3 15.7614 5.23858 18 8 18L15.8788 18L19.5417 19.8887C20.2073 20.2319 21 19.7487 21 18.9999L21 18L21 16L21 7C21 5.34315 19.6569 4 18 4L6 4ZM16 12.25L8 12.25L8 13.75L16 13.75L16 12.25ZM16 8.25L8 8.25L8 9.75L16 9.75L16 8.25Z"
                  fill={fill} fillRule="evenodd"/>
        </svg>
    );
};
